import { STRIPE_SETUP } from './stripeSetupState';

/** Copy and actions describe the current state, never an assumed successful submission. */
export function getStripeSetupNotice({ status, chargesEnabled, disabledReason }) {
  switch (status) {
    case STRIPE_SETUP.CHECKING:
    case STRIPE_SETUP.READY:
      return null;
    case STRIPE_SETUP.PAYOUT_PENDING:
      return {
        title: 'Payments enabled · Payouts not enabled',
        description: disabledReason ? 'You can accept donations. Your payout account needs attention; review its status in Compliance.' : 'You can accept donations. Stripe has not enabled payouts yet. We’ll keep checking automatically.',
        buttonLabel: 'View payment status', destination: '/settings/compliance',
      };
    case STRIPE_SETUP.SUBMITTED:
      return {
        title: 'Stripe setup submitted',
        description: 'Your information has been submitted. Payments are not enabled yet. We’ll automatically check for updates.',
        statusLabel: 'Awaiting Stripe update',
      };
    case STRIPE_SETUP.RESTRICTED:
      return {
        title: 'Payments unavailable',
        description: 'Stripe has restricted this account. Review your payment account status for the next step.',
        buttonLabel: 'View payment status', destination: '/settings/compliance', attention: true,
      };
    case STRIPE_SETUP.ACTION_REQUIRED:
      return {
        title: 'Additional Stripe information required',
        description: chargesEnabled
          ? 'Payments are enabled. Stripe needs updated information to keep your account in good standing.'
          : 'Stripe needs more information before payments can be enabled. Complete the outstanding requirements.',
        buttonLabel: 'Update Stripe information',
        attention: true,
      };
    case STRIPE_SETUP.APPROVAL_SYNCING:
      return {
        title: 'Activating payments in CharityStack',
        description: 'Stripe has enabled payments. CharityStack is confirming activation before publishing and sharing unlock. This updates automatically.',
        statusLabel: 'Confirming activation',
      };
    case STRIPE_SETUP.SYNC_DELAYED:
      return {
        title: 'Activation needs attention',
        description: 'Stripe has approved payments, but CharityStack has not finished updating your account. Contact CharityStack support if this persists. You do not need to resubmit Stripe setup.',
        buttonLabel: 'Contact support', destination: 'support',
        attention: true,
      };
    case STRIPE_SETUP.REVIEW_PENDING:
      return {
        title: 'Stripe verification pending',
        description: 'Stripe is reviewing your information. No action is needed right now. Publishing and sharing unlock once payments are enabled.',
        statusLabel: 'Under review',
      };
    case STRIPE_SETUP.UNAVAILABLE:
      return {
        title: 'Unable to refresh Stripe status',
        description: 'We could not confirm your latest payment status. We’ll keep checking automatically. Your saved setup has not been reset.',
        statusLabel: 'Reconnecting',
      };
    case STRIPE_SETUP.INCOMPLETE:
      return {
        title: 'Finish setting up payments',
        description: 'Your Stripe setup is not complete yet. Continue where you left off to enable payments.',
        buttonLabel: 'Continue Stripe setup',
      };
    default:
      return {
        title: 'Start accepting donations',
        description: 'Connect Stripe to unlock payments. Build and preview your forms anytime.',
        buttonLabel: 'Enable payments',
      };
  }
}
